var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { LocalizationContext } from '../index';
export function withLocalization(Wrapped) {
    var _a;
    var WrappedComponent = Wrapped;
    var wrappedComponentName = WrappedComponent.name;
    var displayName = "localization(".concat(wrappedComponentName, ")");
    if (typeof WrappedComponent === 'function' && React.Component.isPrototypeOf(WrappedComponent)) {
        wrappedComponentName =
            WrappedComponent.displayName || WrappedComponent.name || 'Component';
        displayName = "localization(".concat(wrappedComponentName, ")");
    }
    return _a = /** @class */ (function (_super) {
            __extends(LocalizationComponent, _super);
            function LocalizationComponent() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            LocalizationComponent.prototype.render = function () {
                var _this = this;
                return (React.createElement(LocalizationContext.Consumer, null, function (l10n) { return React.createElement(WrappedComponent, __assign({}, _this.props, { l10n: l10n })); }));
            };
            return LocalizationComponent;
        }(React.Component)),
        _a.wrappedComponent = WrappedComponent,
        _a.displayName = displayName,
        _a;
}
//# sourceMappingURL=with-localization.js.map